(function () {
  var motionSelector = [
    "#MainContent > .shopify-section",
    ".pp-home-ref .pp-ref-hero__content",
    ".pp-ref-benefits article",
    ".pp-ref-side-title",
    ".pp-ref-category-card",
    ".pp-ref-product-card",
    ".pp-ref-variety > div",
    ".pp-ref-variety__chips span",
    ".pp-ref-quiz-strip",
    ".pp-ref-experience",
    ".pp-ref-reviews__title",
    ".pp-ref-reviews article",
    ".pp-ref-brands__head",
    ".pp-ref-brand-card",
    ".pp-home-v2 .pp-hero-v2__content",
    ".pp-home-v2 .pp-hero-v2__media",
    ".pp-benefits-v2 article",
    ".pp-category-card",
    ".pp-variety-v2 .pp-section-head",
    ".pp-variety-v2__grid span",
    ".pp-featured-v2 .pp-section-head",
    ".pp-featured-card",
    ".pp-quiz-v2",
    ".pp-experience-v2",
    ".pp-reviews-v2 .pp-section-head",
    ".pp-reviews-v2 article",
    ".pp-home .pp-hero__content",
    ".pp-home .pp-benefits article",
    ".pp-home .pp-gift__content",
    ".pp-home .pp-gift__card",
    ".pp-home .pp-quiz__content",
    ".pp-home .pp-quiz__steps article",
    ".pp-home .pp-bestsellers__head",
    ".pp-home .pp-product-card",
    ".pp-home .pp-reviews__head",
    ".pp-home .pp-reviews article",
    ".pp-home .pp-final-cta__inner",
    ".pp-product__gallery",
    ".pp-product__summary",
    ".pp-product__consult",
    ".pp-product__fragrance-guide article",
    ".pp-product__gift",
    ".pp-product__assurance",
    ".pp-product__secure-box",
    ".pp-product__promise article",
    ".pp-product__details",
    ".pp-product__match",
    ".pp-product__match-card",
    ".pp-collection__hero > *",
    ".pp-collection__finder",
    ".pp-collection__quicklinks a",
    ".pp-collection__catalogs article",
    ".pp-collection__toolbar",
    ".pp-collection__gift",
    ".pp-collection .pp-product-card",
    ".pp-about__hero-copy",
    ".pp-about__hero-media",
    ".pp-about__values article",
    ".pp-about__trust > *",
    ".pp-about__trust-list article",
    ".pp-about__story-media",
    ".pp-about__story-copy",
    ".pp-about__manifest > *",
    ".pp-about__gallery img",
    ".pp-about__faq-head",
    ".pp-about__faq details",
    ".pp-about__instagram-head",
    ".pp-about__instagram-embed",
    ".pp-cart__head",
    ".pp-cart__item",
    ".pp-cart__summary",
    ".pp-cart__support",
    ".pp-cart__empty",
    ".pp-footer__brand",
    ".pp-footer__col",
    ".pp-footer__bottom",
    ".pp-footer-v2__brand",
    ".pp-footer-v2__col",
    ".pp-footer-v2__newsletter",
    ".pp-footer-v2__bottom",
    ".quiz-shell",
    ".brand-panel",
    ".quiz-panel",
    ".option-btn",
    ".result-layout",
    ".lead-box",
    ".alt-card",
    ".product-card",
    ".collection-card",
    ".predictive-search-results__card"
  ].join(",");

  var observer = null;
  var initQueued = false;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function clearDelay(el) {
    window.setTimeout(function () {
      el.style.transitionDelay = "";
    }, 900);
  }

  function makeVisible(el) {
    el.classList.add("visible");
    clearDelay(el);
  }

  function isInFirstView(el) {
    var rect = el.getBoundingClientRect();
    var height = window.innerHeight || document.documentElement.clientHeight || 0;
    return rect.top < height * 0.92 && rect.bottom > 0;
  }

  function getTargets(scope) {
    var root = scope || document;
    var targets = Array.prototype.slice.call(root.querySelectorAll(motionSelector));

    if (root instanceof Element && root.matches(motionSelector)) {
      targets.unshift(root);
    }

    return targets.filter(function (el, index, list) {
      return list.indexOf(el) === index && !el.closest("[data-pp-no-motion]");
    });
  }

  function getObserver() {
    if (observer) return observer;

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          makeVisible(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: "0px 0px -6% 0px",
        threshold: 0.08
      }
    );

    return observer;
  }

  function initMotion(scope) {
    var targets = getTargets(scope);

    if (!targets.length) return;

    if (prefersReducedMotion() || !("IntersectionObserver" in window)) {
      targets.forEach(function (el) {
        el.classList.add("fade-in", "visible");
        el.style.transitionDelay = "";
      });
      return;
    }

    targets.forEach(function (el, index) {
      if (el.dataset.ppMotionReady === "true") {
        if (!el.classList.contains("visible") && isInFirstView(el)) makeVisible(el);
        return;
      }

      el.dataset.ppMotionReady = "true";
      el.classList.add("fade-in");
      el.classList.add(["pp-motion--lift", "pp-motion--left", "pp-motion--right", "pp-motion--zoom"][index % 4]);
      el.style.transitionDelay = Math.min(index * 44, 260) + "ms";

      if (isInFirstView(el)) {
        window.requestAnimationFrame(function () {
          makeVisible(el);
        });
      } else {
        getObserver().observe(el);
      }

      window.setTimeout(function () {
        var height = window.innerHeight || document.documentElement.clientHeight || 0;
        var rect = el.getBoundingClientRect();
        if (!el.classList.contains("visible") && rect.top < height * 1.2) makeVisible(el);
      }, 1800);
    });
  }

  function initGiftStates(scope) {
    var root = scope || document;

    root.querySelectorAll("[data-pp-gift]").forEach(function (select) {
      var giftBox = select.closest(".pp-product__gift");
      if (!giftBox || select.dataset.ppGiftReady === "true") return;

      select.dataset.ppGiftReady = "true";

      var update = function () {
        giftBox.classList.toggle("has-gift", Boolean(select.value));
      };

      select.addEventListener("change", update);
      update();
    });
  }

  function highlightGiftProperties(scope) {
    var root = scope || document;
    var rows = root.querySelectorAll(".cart-items__property, .pp-cart__properties p");

    rows.forEach(function (row) {
      var text = row.textContent || "";
      if (text.toLowerCase().indexOf("brinde") === -1) return;
      row.classList.add("pp-gift-property");
    });
  }

  function initCartDrawerTrust(scope) {
    var root = scope || document;

    root.querySelectorAll(".cart-drawer, cart-drawer-component").forEach(function (drawer) {
      var summary = drawer.querySelector(".cart-summary, .cart__summary, [data-cart-summary]");
      var target = summary || drawer.querySelector(".cart-items-component") || drawer;

      if (!target || target.querySelector(".pp-drawer-trust")) return;

      var trust = document.createElement("div");
      trust.className = "pp-drawer-trust";
      trust.innerHTML =
        "<strong>Compra segura Palacio Parfum</strong><span>Produto lacrado, brinde 2ml e suporte pelo WhatsApp.</span>";
      target.appendChild(trust);
    });
  }

  function init(scope) {
    initMotion(scope);
    initGiftStates(scope);
    highlightGiftProperties(scope);
    initCartDrawerTrust(scope);
  }

  function scheduleInit(scope) {
    if (initQueued) return;
    initQueued = true;

    window.requestAnimationFrame(function () {
      initQueued = false;
      init(scope || document);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  window.addEventListener("pageshow", function () {
    init(document);
  });

  if ("MutationObserver" in window) {
    var mutationObserver = new MutationObserver(function (mutations) {
      var shouldInit = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length;
      });

      if (shouldInit) scheduleInit(document);
    });

    mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
